import { types } from 'mobx-state-tree';
import { PopupNameType } from './types';

const { model, boolean, string, maybeNull, frozen } = types;

export const PopupStore = model('PopupStore', {
  open: boolean,
  popupName: maybeNull(frozen<PopupNameType>()),
}).actions((self) => ({
  openPopup(name: PopupNameType) {
    self.open = true;
    self.popupName = name;
  },
  closePopup() {
    self.open = false;
    self.popupName = null;
  },
}));
